import type { ReactNode } from "react";
import { withPageErrorBoundary } from "utils/errorHandling";
import { RecherchePageWithErrorBoundary } from "pages/Recherche/RecherchePage";

function HomePage(): ReactNode {
  return <RecherchePageWithErrorBoundary />;
}

export const HomePageWithErrorBoundary = withPageErrorBoundary(HomePage);
